import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

/**
 * Fetch list of assets, paginated.
 * @param {Object} query - Query parameters for pagination and filtering.
 * @returns {Object} JSON response from server.
 */
export const getAssets = async (query) => fetch(getUrl('/assets'), { query });

/**
 * Fetch a single asset by ID.
 * @param {String} id - The ID of the asset to fetch.
 * @returns {Object} JSON response from server.
 */
export const getAsset = async (id) => fetch(getUrl(`/assets/${id}`));

/**
 * Fetch asset directory by ID.
 * @param {String} id - The ID of the directory to fetch.
 * @returns {Object} JSON response from server.
 */
export const getDirectory = async (id) => (
  fetch(getUrl(`/directories/${id}`), {
    query: {
      includeParentTrue: true,
    },
  })
);

/**
 * Fetch presigned upload URL for uploading new file to S3.
 * @param {Object} params - Parameters for generating presigned URL.
 * @returns {Object} JSON response from server.
 */
export const getPresignedUrl = async (params) => {
  const {
    filename,
    contentType,
    type,
  } = params;

  return fetch(getUrl('/assets/upload'), {
    query: {
      filename: encodeURIComponent(filename),
      type,
      contentType: encodeURIComponent(contentType),
    },
  });
};

/**
 * Create a new asset record. This should be called AFTER
 * getting a presigned URL and uploading the asset to S3.
 * This just creates the metadata record for the asset in mongo for tracking.
 * @param {Object} fields - Fields for the new asset.
 * @returns {Object} JSON response from server.
 */
export const createAsset = async (fields = {}) => (
  fetch(getUrl('/assets'), {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(fields),
  })
);
